import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import TableCategory, {
  getTableCategoryFilters,
} from "@/components/Tree/TableCategory";
import ListTable from "@/modules/list-table";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

const FavoritesTable = (listTableProps) => {
  const { t } = useTranslation();

  const defaultColumns = [
    {
      title: t("global:category"),
      dataIndex: "type",
      width: 140,
      className: "type",
      render: (type) => <TableCategory type={type} />,
      filterMode: "tree",
      filters: getTableCategoryFilters(t),
    },
    {
      title: t("global:name"),
      dataIndex: "name",
      className: "table-name",
      render: (name, { id, type }) => (
        <Link to={`/${type}s/${id}`}>{name}</Link>
      ),
      ...TABLE_FILTER_TEXT,
    },
  ];

  return <ListTable columns={defaultColumns} {...listTableProps} />;
};

export default FavoritesTable;
